var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "search-bar" }, [
        _c(
          "div",
          { staticClass: "search-left" },
          [
            _c("label", { staticClass: "search-label" }, [_vm._v("问题名称")]),
            _c("el-input", {
              staticClass: "search-input",
              attrs: { placeholder: "请输入需要查询的问题名称" },
              model: {
                value: _vm.form.name,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "name", $$v)
                },
                expression: "form.name",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-right" },
          [
            _c(
              "el-button",
              { staticClass: "query-btn", on: { click: _vm.fetchData } },
              [_vm._v("查询")]
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.showAddDialog } },
              [_vm._v("新增")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.showImportDialog },
              },
              [_vm._v("导入")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          ref: "table",
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading",
            height: "calc(100vh - 200px)",
            border: "",
            "header-cell-style": { background: "rgb(244 244 244)" },
            "empty-text": "暂无数据",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "问题",
              "min-width": "180",
              fixed: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.question) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "答案", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.answer) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "创建时间", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatDateTime(scope.row.createTime)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作",
              "min-width": "300",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.editItem(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.delItem(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addDialogVisible,
            width: "75%",
            "show-close": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "custom-dialog" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: { model: _vm.qaForm, "label-width": "100px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.qaForm.question,
                          callback: function ($$v) {
                            _vm.$set(_vm.qaForm, "question", $$v)
                          },
                          expression: "qaForm.question",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "答案" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.qaForm.answer,
                          callback: function ($$v) {
                            _vm.$set(_vm.qaForm, "answer", $$v)
                          },
                          expression: "qaForm.answer",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题意图" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.qaForm.questionIntent,
                          callback: function ($$v) {
                            _vm.$set(_vm.qaForm, "questionIntent", $$v)
                          },
                          expression: "qaForm.questionIntent",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "答案意图" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.qaForm.answerIntent,
                          callback: function ($$v) {
                            _vm.$set(_vm.qaForm, "answerIntent", $$v)
                          },
                          expression: "qaForm.answerIntent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "task-check" }, [
                _c("div", { staticClass: "check-name" }, [_vm._v("检查点")]),
                _c(
                  "div",
                  { staticClass: "custom-check" },
                  _vm._l(_vm.qaForm.checkList, function (check, c_i) {
                    return _c(
                      "div",
                      { key: c_i },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea", rows: 2 },
                          model: {
                            value: _vm.qaForm.checkList[c_i],
                            callback: function ($$v) {
                              _vm.$set(_vm.qaForm.checkList, c_i, $$v)
                            },
                            expression: "qaForm.checkList[c_i]",
                          },
                        }),
                        _c("i", {
                          staticClass: "el-icon-circle-plus-outline",
                          on: { click: _vm.addCheck },
                        }),
                        _vm.qaForm.checkList.length > 1
                          ? _c("i", {
                              staticClass: "el-icon-remove-outline",
                              on: {
                                click: function ($event) {
                                  return _vm.qaForm.checkList.splice(c_i, 1)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "custom-btn" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeAddDialog()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.confirmAdd()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.importDialogVisible,
            width: "70%",
            top: "10vh",
            "show-close": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importDialogVisible = $event
            },
          },
        },
        [
          _vm.importStep === 1
            ? _c("div", { staticClass: "mode-dialog" }, [
                _c(
                  "div",
                  { staticClass: "form-item" },
                  [
                    _c("div", { staticClass: "item-name" }, [
                      _vm._v("选择资源"),
                    ]),
                    _c(
                      "el-select",
                      {
                        staticStyle: { "margin-left": "-6px" },
                        attrs: { placeholder: "请选择资源", "value-key": "id" },
                        on: { change: _vm.changeResource },
                        model: {
                          value: _vm.currentResource,
                          callback: function ($$v) {
                            _vm.currentResource = $$v
                          },
                          expression: "currentResource",
                        },
                      },
                      _vm._l(_vm.resourceList, function (resource) {
                        return _c("el-option", {
                          key: resource.id,
                          attrs: { label: resource.name, value: resource },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "form-item task-select" },
                  [
                    _c("div", { staticClass: "item-name" }, [_vm._v("全选")]),
                    _c("el-switch", {
                      attrs: { "active-color": "#419eee" },
                      on: { change: _vm.selectAllTask },
                      model: {
                        value: _vm.allTask,
                        callback: function ($$v) {
                          _vm.allTask = $$v
                        },
                        expression: "allTask",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "dialog-content" }, [
                  _c(
                    "div",
                    { staticClass: "mode-content" },
                    [
                      _c(
                        "el-collapse",
                        _vm._l(_vm.taskList, function (task, index) {
                          return _c(
                            "el-collapse-item",
                            { key: task.id },
                            [
                              _c(
                                "template",
                                { slot: "title" },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: {
                                        change: function ($event) {
                                          return _vm.selectTask(index)
                                        },
                                      },
                                      model: {
                                        value: task.checked,
                                        callback: function ($$v) {
                                          _vm.$set(task, "checked", $$v)
                                        },
                                        expression: "task.checked",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(task.question || task.name) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "tast-detail" }, [
                                _c("div", { staticClass: "question-content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "content-item text" },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "问题： " + _vm._s(task.question)
                                        ),
                                      ]),
                                      _c("div", [
                                        _vm._v("答案： " + _vm._s(task.answer)),
                                      ]),
                                    ]
                                  ),
                                  _c("div", { staticClass: "content-item" }, [
                                    _c("div", [
                                      _vm._v(
                                        "问题意图： " +
                                          _vm._s(task.questionIntent)
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        "答案意图： " +
                                          _vm._s(task.answerIntent)
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "check-list" },
                                  [
                                    _c("div", [_vm._v("检查点：")]),
                                    _vm._l(
                                      task.checkPoints,
                                      function (item, index) {
                                        return _c("div", { key: index }, [
                                          _c("span", [_vm._v(_vm._s(item))]),
                                        ])
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                            ],
                            2
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "dialog-footer" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.importDialogVisible = false
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: !_vm.hasSelectedTask,
                        },
                        on: { click: _vm.nextStep },
                      },
                      [_vm._v("下一步")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.importStep === 2
            ? _c("div", { staticClass: "mode-dialog" }, [
                _c("div", { staticClass: "form-item" }, [
                  _c("div", { staticClass: "item-name" }, [_vm._v("导入预览")]),
                ]),
                _c("div", { staticClass: "dialog-content" }, [
                  _c(
                    "div",
                    { staticClass: "select-list" },
                    _vm._l(_vm.selectedTasks, function (item, task_index) {
                      return _c(
                        "div",
                        {
                          key: task_index,
                          staticClass: "list-item",
                          style: {
                            background:
                              _vm.selectTaskIndex === task_index
                                ? "#ecf5ff"
                                : "",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.editTask(item, task_index)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(item.question || item.name)),
                              ]),
                              item.checkPoints && item.checkPoints.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "check-points-preview" },
                                    _vm._l(
                                      item.checkPoints,
                                      function (checkPoint, idx) {
                                        return _c(
                                          "div",
                                          {
                                            key: idx,
                                            staticClass: "check-point-item",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "检查点" +
                                                  _vm._s(idx + 1) +
                                                  "：" +
                                                  _vm._s(checkPoint)
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c("i", {
                            staticClass: "el-icon-close close-icon",
                            on: {
                              click: function ($event) {
                                return _vm.removeSelectedTask(task_index)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm.showTaskContent
                    ? _c(
                        "div",
                        { staticClass: "tast-detail task-margin" },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "ruleForm",
                              attrs: {
                                model: _vm.taskContent,
                                "label-width": "100px",
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "问题" } },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value: _vm.taskContent.question,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.taskContent,
                                          "question",
                                          $$v
                                        )
                                      },
                                      expression: "taskContent.question",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "答案" } },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value: _vm.taskContent.answer,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.taskContent, "answer", $$v)
                                      },
                                      expression: "taskContent.answer",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "问题意图" } },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value: _vm.taskContent.questionIntent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.taskContent,
                                          "questionIntent",
                                          $$v
                                        )
                                      },
                                      expression: "taskContent.questionIntent",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "答案意图" } },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value: _vm.taskContent.answerIntent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.taskContent,
                                          "answerIntent",
                                          $$v
                                        )
                                      },
                                      expression: "taskContent.answerIntent",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "task-check" }, [
                            _c("div", { staticClass: "check-name" }, [
                              _vm._v("检查点"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "custom-check" },
                              _vm._l(
                                _vm.taskContent.checkList,
                                function (check, c_i) {
                                  return _c(
                                    "div",
                                    { key: c_i },
                                    [
                                      _c("el-input", {
                                        attrs: { type: "textarea", rows: 2 },
                                        model: {
                                          value: _vm.taskContent.checkList[c_i],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.taskContent.checkList,
                                              c_i,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "taskContent.checkList[c_i]",
                                        },
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-circle-plus-outline",
                                        on: { click: _vm.addCheckPoint },
                                      }),
                                      _vm.taskContent.checkList.length > 1
                                        ? _c("i", {
                                            staticClass:
                                              "el-icon-remove-outline",
                                            on: {
                                              click: function ($event) {
                                                return _vm.taskContent.checkList.splice(
                                                  c_i,
                                                  1
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c(
                  "div",
                  { staticClass: "dialog-footer" },
                  [
                    _c("el-button", { on: { click: _vm.prevStep } }, [
                      _vm._v("上一步"),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmImport },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }